(() => {
  const init = () => {
    const drawer = document.querySelector('cart-drawer-component');
    if (!drawer || drawer.dataset.ambConversionEnhanced) return;
    drawer.dataset.ambConversionEnhanced = 'true';

    const addTrustBar = () => {
      const summary = drawer.querySelector('.cart-drawer__summary');
      if (!summary || summary.querySelector('.amb-cart-trust')) return;
      const trust = document.createElement('div');
      trust.className = 'amb-cart-trust';
      trust.innerHTML = '<strong>NEED FITMENT HELP?</strong><span>Not sure this part fits your build? Send AMB Fab your make, model, measurements, or photos before checkout.</span><div class="amb-cart-trust__actions"><a href="/pages/contact">CONTACT AMB FAB →</a><a href="/collections/mini-bike-brakes">KEEP SHOPPING →</a></div>';
      summary.prepend(trust);
    };

    const handleCartUpdate = (event) => {
      if (event.detail?.data?.didError) return;
      addTrustBar();
    };

    const handleCartAdd = (event) => {
      if (event.detail?.data?.didError) return;
      addTrustBar();
      if (!drawer.hasAttribute('auto-open') && typeof drawer.open === 'function') drawer.open();
    };

    addTrustBar();
    document.addEventListener('cart:update', handleCartUpdate);
    document.addEventListener('cart:update', handleCartAdd);

    drawer.addEventListener('dialog:open', addTrustBar);

    drawer.addEventListener('dialog:close', () => {
      drawer.querySelector('.amb-cart-trust')?.remove();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
